import useSWR from 'swr';
import reportsService from '../../services/reports.service';

const SWR_CACHE_KEY = 'reports';

const useReports = () => {
    // Revalidation on focus and when stale is deliberately on: an admin can change a
    // user's report access at any time in the auth control panel, and the nav entry is
    // driven by this same list, so a frozen cache would keep showing (or hiding)
    // reports until a hard reload.
    const { data, isLoading, error } = useSWR(SWR_CACHE_KEY, () => reportsService.getReports(), {
        revalidateOnFocus: true,
        revalidateOnReconnect: true,
        refreshWhenHidden: false,
        refreshWhenOffline: false,
        revalidateIfStale: true,
    });

    const reports = data?.data?.reports;

    return {
        reports,
        isLoading: isLoading || !data,
        error,
        // Nav uses this to decide whether to render the Reports entry at all. Undefined
        // until the request resolves, so callers can hold off rather than flashing the
        // link in and then removing it for the majority of users who have none.
        hasReports: data ? Boolean(reports?.length) : undefined,
    };
};

export default useReports;
